import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { ApiFetch } from '../../../Utils/ApiFetch';
import useGlobalContext from '../../../Hooks/useGlobalContext';
import { useTranslation } from 'react-i18next';

const AssetSelectEstablishmentFilter = ({
  selectedValidatedCompany,
  onChangeCompany,
  selectedValidatedBox,
  onChangeBox,
}) => {
  const { selectedCompany } = useGlobalContext();
  const globalContext = useGlobalContext();
  const { t } = useTranslation();
  const [validatedBoxes, setValidatedBoxes] = useState([]);
  const [validatedCompanies, setValidatedCompanies] = useState([]);

  const getValidatedBoxes = (validatedCompanyId) => {
    ApiFetch(
      `validations/${selectedCompany.id}/box/${validatedCompanyId}`,
      globalContext,
      true,
      async (result) => {
        try {
          let boxes = [];
          const resValidatedBoxes = await result.json();
          for (let b of resValidatedBoxes) {
            boxes.push({ id: b.id, label: b.name });
          }
          setValidatedBoxes(boxes);
        } catch (e) {
          console.error('Error processing company validations:', e);
        }
      },
      (error) => {
        console.error('Error fetching company validations:', error);
      },
      {
        method: 'GET',
      }
    );
  };

  useEffect(() => {
    ApiFetch(
      `validations/${selectedCompany.id}/company`,
      globalContext,
      true,
      async (result) => {
        try {
          let companies = [];
          const resValidatedComapnies = await result.json();
          for (let c of resValidatedComapnies) {
            if (c.validated_at) companies.push({ id: c.id, label: c.name });
          }
          setValidatedCompanies(companies);
        } catch (e) {
          console.error('Error processing company validations:', e);
        }
      },
      (error) => {
        console.error('Error fetching company validations:', error);
      },
      {
        method: 'GET',
      }
    );
  }, []);

  const onChangeCompanyHandler = (val) => {
    const selectedId = val.target.value;
    onChangeBox(null);
    if (selectedId === '') {
      onChangeCompany(null);
      setValidatedBoxes([]);
    } else {
      const selectedCompany = validatedCompanies.find(
        (c) => c.id === selectedId
      );
      onChangeCompany({
        id: selectedId,
        label: selectedCompany?.label || '',
      });
      getValidatedBoxes(selectedId);
    }
  };

  const onChangeBoxHandler = (val) => {
    const selectedId = val.target.value;
    if (selectedId === '') {
      onChangeBox(null);
    } else {
      const selectedBox = validatedBoxes.find((c) => c.id === selectedId);
      onChangeBox({
        id: selectedId,
        label: selectedBox?.label || '',
      });
    }
  };

  return (
    <Grid item xs={12}>
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel size="small" id="selectValidatedCompanyLabel">
                {validatedCompanies.length === 0
                  ? t('validations.common.filter.emptyCompanies')
                  : t('validations.common.filter.selectCompany')}
              </InputLabel>
              <Select
                value={selectedValidatedCompany?.id || ''}
                onChange={onChangeCompanyHandler}
                id="selectValidatedCompany"
                name={'selectValidatedCompany'}
                label={
                  validatedCompanies.length === 0
                    ? t('validations.common.filter.emptyCompanies')
                    : t('validations.common.filter.selectCompany')
                }
                labelId="selectValidatedCompanyLabel"
                size="small">
                <MenuItem value="">
                  <em>{t(`miscellaneous.deselect`)}</em>
                </MenuItem>
                {validatedCompanies.map((c, index) => (
                  <MenuItem value={c.id} key={'selectValidatedCompany' + index}>
                    {c.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel size="small" id="selectValidatedBoxLabel">
                {validatedBoxes.length === 0
                  ? !selectedValidatedCompany
                    ? t('validations.common.filter.selectBox')
                    : t('validations.common.filter.emptyBoxes')
                  : t('validations.common.filter.selectBox')}
              </InputLabel>
              <Select
                disabled={validatedBoxes.length === 0}
                value={selectedValidatedBox?.id || ''}
                onChange={onChangeBoxHandler}
                id="selectValidatedBox"
                name={'selectValidatedBox'}
                label={
                  validatedBoxes.length === 0
                  ? !selectedValidatedCompany
                    ? t('validations.common.filter.selectBox')
                    : t('validations.common.filter.emptyBoxes')
                  : t('validations.common.filter.selectBox')
                }
                labelId="selectValidatedBoxLabel"
                size="small">
                <MenuItem value="">
                  <em>{t(`miscellaneous.deselect`)}</em>
                </MenuItem>
                {validatedBoxes.map((b, index) => (
                  <MenuItem value={b.id} key={'selectValidatedBox' + index}>
                    {b.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

export default AssetSelectEstablishmentFilter;
